import { DisplayMode } from '../../ts/ServerApi/types/ISessionInfo';

export const DisplayModeUrlKey = 'mode';
export type updateExplorerDisplayMode = (displayModeFromUrlOrUndefined: DisplayMode, saveToServer: boolean) => void;

/**
 * Unlike content filters, the URL is not the source of truth for display settings. However, URL
 * flags can dictate the display settings' initial values, and changes in the URL can trigger
 * updates to the display settings. Since we don't yet have an elegant system in React/Redux to
 * watch the URL and dispatch the relevant actions, those watchers are set up here.
 */

export function setDisplayModeFromUrlIfParamIsPresent(queryString: any, updateExplorerDisplayMode: updateExplorerDisplayMode) {
  const displayModeFromUrlOrUndefined = getDisplayModeFromUrl(queryString);
  if (displayModeFromUrlOrUndefined) {
    // The URL flag is considered a browser-local override for test automation only,
    // so we don't save that setting to the server
    updateExplorerDisplayMode(displayModeFromUrlOrUndefined, false);
  }
}

function getDisplayModeFromUrl(queryString: any): DisplayMode | undefined {
  const displayModeFromUrl = queryString[DisplayModeUrlKey];

  switch (displayModeFromUrl) {
    case 'list':
    case 'thumbnail':
      return displayModeFromUrl;
    default:
      return undefined;
  }
}
